/* TAPS quiz kinetic engine — ported from quiz-lab/quiz-revamp-layout.html.
   Reads questions + bands from the section's JSON payload (script.qk-data).
   Answer motion: dim siblings -> scanline sweep .35s -> LOGGED stamp (elastic)
   -> meter segment pop -> cross-axis wipe. Reduced motion: instant swap.
   Scoring: 0-50 -> 4 bands; gap chips light at per-question score <= 2 (worst 3). */
(function () {
  "use strict";

  function boot(root) {
    if (!root || root.__qk) return;
    root.__qk = true;

    var dataEl = root.querySelector("script.qk-data");
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var QUESTIONS = (data.questions || []).filter(function (q) {
      return q && q.text && q.options && q.options.length;
    });
    var BANDS = data.bands || [];
    var MAX = data.maxScore || 50;
    if (!QUESTIONS.length) return;

    var TOTAL = QUESTIONS.length;
    var reduced = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;

    var consoleEl = root.querySelector(".qk-console");
    var meterEl = root.querySelector(".qk-meter");
    var readoutEl = root.querySelector(".qk-readout");
    var viewport = root.querySelector(".qk-viewport");
    var resultEl = root.querySelector(".qk-result");
    if (!consoleEl || !meterEl || !viewport) return;

    var current = 0, answered = 0, busy = false;
    var scores = [];

    for (var i = 0; i < TOTAL; i++) {
      var seg = document.createElement("div");
      seg.className = "qk-seg";
      meterEl.appendChild(seg);
    }

    function pad(n) { return (n < 10 ? "0" : "") + n; }
    function updateReadout() {
      if (readoutEl) readoutEl.textContent = "Signal " + pad(answered) + "/" + TOTAL;
    }

    function esc(s) {
      var d = document.createElement("div");
      d.textContent = s == null ? "" : String(s);
      return d.innerHTML;
    }

    function buildFrame(qi) {
      var q = QUESTIONS[qi];
      var frame = document.createElement("div");
      frame.className = "qk-frame";
      frame.innerHTML =
        '<p class="qk-qtag">Signal ' + pad(qi + 1) + " · " + esc(q.tagLabel || q.tag) + "</p>" +
        '<h3 class="qk-qtext">' + esc(q.text) + "</h3>" +
        '<div class="qk-options"></div>';
      var wrap = frame.querySelector(".qk-options");
      q.options.forEach(function (label, idx) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "qk-opt";
        btn.innerHTML =
          '<span class="qk-key">' + String.fromCharCode(65 + idx) + "</span>" +
          '<span class="qk-opt-label">' + esc(label) + "</span>" +
          '<span class="qk-scanline" aria-hidden="true"></span>' +
          '<span class="qk-verdict">Logged</span>';
        btn.addEventListener("click", function () { pick(btn, frame, qi, idx); });
        wrap.appendChild(btn);
      });
      return frame;
    }

    /* frames are absolutely positioned (for the cross-axis wipe), so the viewport
       can't auto-grow — size it to the mounted frame or long option lists clip. */
    function sizeViewport(frame) {
      requestAnimationFrame(function () {
        var h = frame.offsetHeight;
        if (h > 0) viewport.style.height = Math.max(h, 420) + "px";
      });
    }

    function mount(qi, animateIn) {
      var frame = buildFrame(qi);
      if (animateIn && !reduced) frame.classList.add("qk-entering");
      viewport.appendChild(frame);
      sizeViewport(frame);
      frame.addEventListener("animationend", function () {
        frame.classList.remove("qk-entering");
      });
      return frame;
    }

    var rsT = null;
    window.addEventListener("resize", function () {
      clearTimeout(rsT);
      rsT = setTimeout(function () {
        var f = viewport.lastElementChild;
        if (f) sizeViewport(f);
      }, 120);
    });

    function pick(optEl, frame, qi, oi) {
      if (busy) return;
      busy = true;
      consoleEl.classList.add("qk-locked");
      var q = QUESTIONS[qi];
      scores[qi] = (q.scores && q.scores[oi] != null) ? q.scores[oi] : 0;

      frame.querySelectorAll(".qk-opt").forEach(function (s) {
        if (s !== optEl) s.classList.add("qk-dimmed");
      });

      if (reduced || !optEl.animate) {
        optEl.classList.add("qk-logged");
        fillSegment();
        setTimeout(function () { advance(frame); }, 150);
        return;
      }

      optEl.classList.add("qk-assessing");
      var scan = optEl.querySelector(".qk-scanline");
      var sweep = scan.animate(
        [{ transform: "translateX(-110%)" }, { transform: "translateX(330%)" }],
        { duration: 350, easing: "cubic-bezier(.22,1,.36,1)" }
      );
      sweep.onfinish = function () {
        optEl.classList.remove("qk-assessing");
        optEl.classList.add("qk-logged");
        fillSegment();
        setTimeout(function () { advance(frame); }, 220);
      };
    }

    function fillSegment() {
      var segs = meterEl.children;
      if (answered < TOTAL) {
        var seg = segs[answered];
        seg.classList.add("qk-filled");
        if (!reduced) seg.classList.add("qk-popping");
        answered++;
        updateReadout();
      }
    }

    function advance(oldFrame) {
      var done = current + 1 >= TOTAL;
      if (reduced) {
        oldFrame.remove();
        finish(done);
        return;
      }
      oldFrame.classList.add("qk-exiting");
      oldFrame.addEventListener("animationend", function () {
        oldFrame.remove();
        finish(done);
      }, { once: true });
    }

    function finish(done) {
      if (done) { showResult(); return; }
      current++;
      mount(current, true);
      busy = false;
      consoleEl.classList.remove("qk-locked");
    }

    /* ---- result ---- */
    function showResult() {
      var total = scores.reduce(function (a, b) { return a + (b || 0); }, 0);
      var pct = Math.max(0, Math.min(100, Math.round((total / MAX) * 100)));

      var band = BANDS[0] || {};
      for (var bi = 0; bi < BANDS.length; bi++) {
        if (total >= (BANDS[bi].min || 0)) band = BANDS[bi];
      }

      /* gap chips: light when question scored <=2; worst 3, lowest first, block-order tiebreak */
      var flagged = [];
      QUESTIONS.forEach(function (q, qi) {
        if (q.chip && (scores[qi] || 0) <= 2) flagged.push({ chip: q.chip, s: scores[qi] || 0, i: qi });
      });
      flagged.sort(function (a, b) { return a.s - b.s || a.i - b.i; });
      var chips = flagged.slice(0, 3).map(function (f) { return f.chip; });
      if (!chips.length) chips = [band.noGapChip || "Fully current"];

      if (resultEl) {
        var set = function (sel, txt) { var el = resultEl.querySelector(sel); if (el) el.textContent = txt; };
        set(".qk-band", "Verdict · " + (band.name || ""));
        set(".qk-verdict-title", band.title || "");
        set(".qk-verdict-copy", band.copy || "");
        var ctaBtn = resultEl.querySelector(".qk-btn .qk-btn-label");
        if (ctaBtn && band.cta) ctaBtn.textContent = band.cta;
        var flagsEl = resultEl.querySelector(".qk-flags");
        if (flagsEl) {
          flagsEl.innerHTML = "";
          chips.forEach(function (c) {
            var f = document.createElement("span");
            f.className = "qk-flag";
            f.textContent = c;
            flagsEl.appendChild(f);
          });
        }
        resultEl.hidden = false;
        var card = resultEl.querySelector(".qk-result-card");
        if (window.gsap && !reduced && card) {
          window.gsap.fromTo(card, { opacity: 0, y: 36 }, { opacity: 1, y: 0, duration: 0.8, ease: "power4.out" });
        }

        /* console fades to done state */
        var hint = root.querySelector(".qk-hint-state");
        if (hint) hint.textContent = "Scan complete";

        resultEl.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });

        /* gauge + count-up */
        var fill = resultEl.querySelector(".qk-gauge-fill");
        var num = resultEl.querySelector(".qk-gauge-num strong");
        var C = 471;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (fill) fill.style.strokeDashoffset = String(C - (C * pct) / 100);
          });
        });
        if (num) {
          if (reduced) { num.textContent = String(pct); }
          else {
            var t0 = null;
            var step = function (ts) {
              if (!t0) t0 = ts;
              var k = Math.min(1, (ts - t0) / 1100);
              var e = 1 - Math.pow(1 - k, 4);
              num.textContent = String(Math.round(pct * e));
              if (k < 1) requestAnimationFrame(step);
            };
            requestAnimationFrame(step);
          }
        }
      }
      busy = true; /* quiz stays locked after completion */
    }

    updateReadout();
    mount(0, false);
    entrance(root, reduced);
  }

  /* ---- brand entrance (same kinetic language as home/PDP) ----
     Headline word mask-rise -> eyebrow/sub/boot-strip rise -> console elastic
     punch-in with meter segments staggering alive -> footer strip rise.
     Gate: .qk-js primed the hidden states pre-paint; GSAP releases them. */
  function splitWords(el) {
    var walk = function (node) {
      var kids = Array.prototype.slice.call(node.childNodes);
      kids.forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var w = document.createElement("span");
            w.className = "qk-w";
            var i = document.createElement("i");
            i.textContent = part;
            w.appendChild(i);
            frag.appendChild(w);
          });
          node.replaceChild(frag, n);
        } else if (n.nodeType === 1) walk(n);
      });
    };
    walk(el);
  }

  function entrance(root, reduced) {
    var g = window.gsap;
    if (!g || reduced) { root.classList.remove("qk-js"); return; }
    var ST = window.ScrollTrigger;
    if (ST) { try { g.registerPlugin(ST); } catch (e) {} }

    var h1 = root.querySelector(".qk-h1");
    if (h1 && !h1.__qkSplit) { h1.__qkSplit = true; splitWords(h1); }
    var words = root.querySelectorAll(".qk-w i");

    var tl = g.timeline({ defaults: { ease: "power4.out" } });
    tl.to(root.querySelector(".qk-eyebrow"), { opacity: 1, y: 0, duration: 0.6 }, 0.05);
    if (words.length) tl.to(words, { y: 0, duration: 0.85, stagger: 0.045 }, 0.12);
    tl.to(root.querySelector(".qk-sub"), { opacity: 1, y: 0, duration: 0.7 }, 0.42)
      .to(root.querySelector(".qk-boot-strip"), { opacity: 1, y: 0, duration: 0.7 }, 0.56);

    /* boot-strip system check: items flicker on one by one, status dot pings last */
    var bootItems = root.querySelectorAll(".qk-boot-item");
    if (bootItems.length) {
      tl.to(bootItems, {
        keyframes: [
          { opacity: 1, duration: 0.07 },
          { opacity: 0.25, duration: 0.06 },
          { opacity: 1, duration: 0.05 },
          { opacity: 0.5, duration: 0.05 },
          { opacity: 1, duration: 0.1 }
        ],
        stagger: 0.22
      }, 0.78);
    }
    var bootDot = root.querySelector(".qk-boot-dot");
    if (bootDot) tl.to(bootDot, { scale: 1, duration: 0.55, ease: "elastic.out(1,.5)" }, 0.86);

    var consoleEl = root.querySelector(".qk-console");
    var segs = root.querySelectorAll(".qk-rail .qk-seg");
    var readout = root.querySelector(".qk-readout");
    function consoleIn() {
      var ctl = g.timeline({ defaults: { ease: "power4.out" } });
      ctl.to(consoleEl, { opacity: 1, y: 0, scale: 1, duration: 0.9, ease: "elastic.out(1,.62)" }, 0)
        .to(segs, { scaleX: 1, duration: 0.45, stagger: 0.05, ease: "power3.out" }, 0.25)
        .to(readout, { opacity: 1, duration: 0.5 }, 0.55);
    }
    if (ST && consoleEl) {
      ST.create({ trigger: consoleEl, start: "top 82%", once: true, onEnter: consoleIn });
      /* already in view on load */
      if (consoleEl.getBoundingClientRect().top < window.innerHeight * 0.82) consoleIn();
    } else {
      tl.add(consoleIn, 0.5);
    }

    var fsText = root.querySelector(".qk-footer-strip .qk-fs-text");
    var fsLink = root.querySelector(".qk-footer-strip .qk-fs-link");
    if (ST && fsText) {
      ST.create({
        trigger: root.querySelector(".qk-footer-strip"), start: "top 92%", once: true,
        onEnter: function () {
          g.to([fsText, fsLink], { opacity: 1, y: 0, duration: 0.7, stagger: 0.08, ease: "power4.out" });
        }
      });
    } else {
      g.set([fsText, fsLink], { opacity: 1, y: 0 });
    }
  }

  function init() {
    document.querySelectorAll("[data-qk-root]").forEach(boot);
  }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
